import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ValidatorPattern } from '../utility/validators.pattern';

@Directive({
  selector: '[appValidAlphabets]',
})
export class AppValidAlphabetsDirective {
  private readonly allowedChars = ['A', 'B', 'C'];

  constructor(
    private readonly el: ElementRef<HTMLInputElement>,
    private readonly control: NgControl
  ) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;

    // Allow navigation keys
    const controlKeys = [
      'Backspace',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
    ];
    if (controlKeys.includes(key)) return;

    const upperKey = key.toUpperCase();

    if (!this.allowedChars.includes(upperKey)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = this.el.nativeElement;
    const start = input.selectionStart ?? input.value.length;

    const transformedValue = input.value
      .toUpperCase()
      .replaceAll(new RegExp(ValidatorPattern.ValidAlphabetsOnly, 'g'), '');
    input.value = transformedValue;

    if (this.control.control) {
      this.control.control.setValue(transformedValue, { emitEvent: false });
    }

    // Restore cursor position
    input.setSelectionRange(start, start);
  }
}
